// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_dYLrD){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3Gx3e .dualColumn_1MwLY{display:flex;align-content:space-between}.nsAddressForm_3Gx3e .dualColumn_1MwLY .firstCol_1c4d9{margin-right:20px}.optional_2OnhY{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_dYLrD",
	"nsAddressForm": "nsAddressForm_3Gx3e",
	"dualColumn": "dualColumn_1MwLY",
	"firstCol": "firstCol_1c4d9",
	"optional": "optional_2OnhY"
};
module.exports = exports;
